import { ManufacturerRepository } from '../data/manufacturer-repository';
import { ManufacturerResponse } from '../types/manufacturer-types';

export class GetManufacturersUseCase {
  constructor(private readonly repository: ManufacturerRepository) {}

  async execute(): Promise<ManufacturerResponse> {
    return this.repository.getAll();
  }
}
